'use strict';

class GpcConsent {
	constructor(props = {}) {
		Object.assign(this, props);

		this.stateEvent = 'gpc:statechange';
		this.onOffSelector = '.on_off_settings_holder [data-on_off]';
		this.forms = [];

		console.log('GpcConsent::constructor(%o)', this);

		try {
			this.init();
		} catch (error) {
			console.error('GPC consent error:', error);
		}
	}

	init() {
		// Collect all GPC forms on the page
		this.forms = Array.from(document.querySelectorAll('.gpc_form'));
		if (!this.forms.length) return;

		this.pageEvents();
		this.handleBrowserGPC();
	}

	pageEvents() {
		this.forms.forEach(form => {
			form.addEventListener('submit', (e) => e.preventDefault());
			form.addEventListener('click', (e) => {
				const btn = e.target.closest(this.onOffSelector);
				if (btn && !btn.disabled) {
					this.handleButtonClick(e, btn);
				}
			});
			form.addEventListener(this.stateEvent, (e) => {
				const {enabled, source} = e.detail;
				if (source === this) return;

				const buttons = form.querySelectorAll(this.onOffSelector);
				buttons.forEach(btn => {
					if (btn.disabled) return;
					const isOn = btn.dataset.on_off === 'off';
					btn.classList.toggle('active', enabled === isOn);
				});
			});
		});
	}

	updateAllButtons(gpcEnabled) {
		this.forms.forEach(form => {
			const buttons = form.querySelectorAll(this.onOffSelector);
			buttons.forEach(btn => {
				if (btn.disabled) return;
				const isOn = btn.dataset.on_off === 'off';
				btn.classList.toggle('active', gpcEnabled === isOn);
			});
		});
	}

	handleBrowserGPC() {
		const browserGpc = detectBrowserGPC();

		// Only enforce when browser GPC is explicitly enabled by the user
		if (browserGpc !== 'enabled') {
			return;
		}

		const gpcEnabled = this.forms.some(form => form.dataset.gpc_enabled === '1');

		if (!gpcEnabled) {
			this.processConsent(true, 'browser');
		}

		this.updateAllButtons(true);
		this.hideConsentBanner();
		this.denyGtagConsents();

		// Disable user interaction - browser enforces GPC
		this.disableUserToggles();
	}

	disableUserToggles() {
		this.forms.forEach(form => {
			const buttons = form.querySelectorAll(this.onOffSelector);
			buttons.forEach(btn => {
				btn.setAttribute('disabled', true);
			});
		});
	}

	setGpcState(enabled, source = null) {
		this.forms.forEach(form => {
			form.dispatchEvent(
				new CustomEvent(this.stateEvent, {
					detail: {enabled, source}
				})
			);
		});
	}

	denyGtagConsents() {
		try {
			const consent = Object.assign({}, STORE.user_consent);

			// Fields that must be forced to "denied" under GPC
			const deniedKeys = [
				'analytics_storage',
				'ad_personalization',
				'ad_user_data',
				'ad_storage'
			];

			let updated = false;
			if (consent && typeof consent === 'object') {
				deniedKeys.forEach(key => {
					if (consent[key] !== 'denied') {
						consent[key] = 'denied';
						updated = true;
					}
				});
			}

			// Only call gtag if we actually changed something
			if (updated) {
				this.updateGtag(consent);
			}

		} catch (err) {
			console.warn('Deny gtag consents error:', err);
		}
	}

	updateGtag(userConsent) {
		if (typeof gtag === 'function') {
			gtag('consent', 'update', userConsent);
		}
	}

	handleButtonClick(e, btn) {
		e.preventDefault();

		if (btn.classList.contains('active')) return;

		const gpcSource = btn.dataset.source;
		const gpcEnabled = btn.dataset.on_off === 'off';
		if (gpcEnabled) {
			this.denyGtagConsents();
		}

		this.processConsent(gpcEnabled, gpcSource);
		this.setGpcState(gpcEnabled, this);
		this.updateAllButtons(gpcEnabled);
		this.closeModal();
	}

	processConsent(gpcEnabled, gpcSource) {
		const formData = new FormData();
		formData.append('type', 'gpc');
		formData.append('gpc_enabled', gpcEnabled);
		if (gpcSource) {
			formData.append('gpc_source', gpcSource);
		}

		fetcher(
			url('/process_consent'),
			{
				method: 'POST',
				body: formData
			}
		);
	}

	hideConsentBanner() {
		const footer = document.querySelector('#footer_overlay');
		if (footer) {
			footer.style.setProperty('display', 'none', 'important');
		}
	}

	closeModal() {
		setTimeout(() => {
			$('#gpc_consent').modal('hide');
		}, 400);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	try {
		new GpcConsent();
	} catch (e) {
		console.error(e);
	}
});
